import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { editSisPriceMemoEndpoint } from '../../../common/endpoints';

export const editSisPriceMemoApi = createApi(editSisPriceMemoEndpoint, 'PUT');

const EditSisPriceMemo = createSlice({
  name: 'EditSisPriceMemo',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(editSisPriceMemoApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editSisPriceMemoApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(editSisPriceMemoApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default EditSisPriceMemo.reducer;